import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Education({initialData}) {


    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/commercial-washing-machine-for-university",
                name: "Education"
            }
        ]

    }




    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Laundry Built for Campus Life",
        description: "Purpose-built laundry systems for schools, colleges, and universities, handling everything from sports uniforms to hostel bedding with institutional durability, budget-friendly efficiency, and student-safe hygiene standards.",
        image: "/assets/images/educational-banner1.webp"
    };

    const excellenceData = {
        subtitle: "Educational Institution Specialists",
        title: "Keeping Campuses Clean, Healthy, and Budget-Compliant",
        description1: "Athletic programs need clean uniforms daily. Hostels process hundreds of bedsheets weekly. School nurses require sanitized linens. Your campus laundry isn't just washing clothes, it's supporting student health, athletic performance, and residential satisfaction on limited budgets.",
        description2: "Supershine builds laundry operations for educational realities: high volumes, tight budgets, non-technical staff, and zero tolerance for downtime during term. We've equipped 400+ schools and universities because we understand institutional constraints vendors ignore.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };

    const facilityData = {
        title: "Engineered for Educational <br> Demands",
        items: [
            {
                icon: "/assets/images/educational-icon1.webp",
                heading: "Student Health Protection",
                description: " Validated sanitization eliminates bacteria and viruses from athletic wear, hostel linens, and nurse station textiles protecting campus health."
            },
            {
                icon: "/assets/images/educational-icon2.webp",
                heading: "Built for Campus Abuse",
                description: "Reinforced construction withstands constant daily use from multiple untrained operators without frequent breakdowns or repairs needed."
            },
            {
                icon: "/assets/images/educational-icon3.webp",
                heading: "Foolproof Operation",
                description: "Simple controls let housekeeping staff, student workers, and facilities teams operate equipment correctly without extensive technical training."
            },

            {
                icon: "/assets/images/educational-icon4.webp",
                heading: "Growth-Ready Capacity",
                description: "Add machines as enrollment increases or seasonal sports demand spikes without replacing entire systems or major infrastructure overhauls."
            },

            {
                icon: "/assets/images/educational-icon5.webp",
                heading: "Institutional Longevity",
                description: "Commercial-grade components deliver 15-20 year service life under heavy educational use protecting limited capital budgets long-term."
            },


            {
                icon: "/assets/images/educational-icon6.webp",
                heading: "Utility Bill Reduction",
                description: "Efficient water and energy systems cut operating costs 35% versus older equipment, freeing budget for academics, not utilities."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Serving Educational Institutions Nationwide",
        stats: [
            {
                end: 400,
                suffix: "+",
                text: " Schools & Universities <br> Equipped",
            },
            {
                end: 98,
                suffix: "%",
                text: "Meet Health <br>  Safety Standards",
            },
            {
                end: 800,
                suffix: "+",
                text: " Student Loads <br>  Daily Capacity",
            },
            {
                prefix: "",
                end: 35,
                suffix: "%",
                text: "Lower Utility <br>  Expenses Achieved",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Stop Wasting Budget on Outsourcing`,
        description: "Most institutions spend 3-5x more outsourcing laundry versus in-house processing. Our systems typically achieve full payback within 3-4 years while improving turnaround speed, quality control, and hygiene standards for student welfare.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/educational-left-image.webp",
        title: "Why Campuses Choose In-House Laundry",
        subtitle: "The Educational Advantage:",
        reasons: [
            "Protect student health directly through controlled sanitization temperatures, validated cycles, and consistent hygiene versus unpredictable vendor processes.",
            "Slash operational expenses permanently by eliminating per-pound fees, pickup charges, and vendor contracts, redirecting funds toward educational priorities annually.",
            "Handle athletic seasons smoothly with instant processing capacity for team uniforms, practice gear, and equipment without waiting days for vendor returns.",
            "Accommodate enrollment changes easily through scalable systems that add capacity incrementally as student population grows without major reinvestment.",
            "Operate with confidence using simplified controls, automated programs, and foolproof design requiring minimal training for rotating staff members."
        ],
        buttonText: "Design Your Hotel Solution",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/institute-brand-logo1.webp", title: "Brand 1" },
            { image: "/assets/images/institute-brand-logo2.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo3.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo4.webp", title: "Brand 4" },
            { image: "/assets/images/institute-brand-logo6.webp", title: "Brand 6" },
            { image: "/assets/images/institute-brand-logo7.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo8.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo9.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo10.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo11.webp", title: "Brand 3" },
        ]
    };



    const businessData = {
        title: "Recommended By <br/> Institutions Across India.",
        description:
            "Schools and universities turn to Supershine for high-capacity processing, consistent results, and dependable laundry solutions built for institutional scale.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“With over 2,000 students across our hostels, laundry was one of our biggest operational headaches. Supershine's high-capacity machines completely changed that; processing volumes that used to take days now happen in hours, and complaints from students have dropped sharply.”",
                client: "Pradeep Nambiar, Hostel Administration Head, University Campus",
            },
            {
                rating: 5,
                text:
                    "“Hygiene and scheduling are both critical when you're managing linen for a residential school. Supershine's equipment gave us predictable cycle times that fit neatly into our daily routines, and the consistent results mean parents have no concerns about cleanliness standards. ”",
                client: "Rashmi Verma, Operations Head, Residential School",
            },
            {
                rating: 5,
                text:
                    "“As an educational institution, every equipment purchase has to justify itself against a tight budget. Supershine's machines have lowered our water and energy costs significantly while increasing our processing capacity, which made the return on investment clear within the first year itself.”",
                client: "Deepak Choudhary, Facilities Manager, Educational Institution",
            },
        ],
    };



    const productData = {
        subtitle: "Recommended Products",
        title: "Superior Laundry Solutions <br> For Student Communities",
     
    };


    const faqData = {
        title: "FAQs",
        description: "Practical answers for educational facility planning and budget decisions.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "How do schools justify laundry equipment costs on tight budgets?",
                answer: "Most institutions achieve 3-4 year payback through eliminated outsourcing fees. Grant funding, capital budgets, and donor contributions often cover initial investment. Monthly savings from avoided vendor fees typically exceed equipment financing payments, creating immediate positive cash flow.",
            },
            {
                question: " Can non-technical staff operate institutional laundry equipment safely?",
                answer: "Yes. Our systems feature simplified controls, pre-programmed cycles, automatic chemical dispensing, and visual operation guides. Housekeeping staff, student workers, and facilities teams operate equipment successfully with 1-2 hours basic training, no technical expertise required.",
            },
            {
                question: "How much space does campus laundry require?",
                answer: "Space needs depend on student population: 500 students need roughly 300-400 sq ft; 2000+ students need 800-1200 sq ft. We design layouts maximizing existing spaces including basements, service areas, or underutilized building zones, most campuses have adequate room available.",
            },

            {
                question: "What maintenance do educational laundry systems require?",
                answer: "Quarterly preventive maintenance (filter cleaning, seal inspection, calibration checks) plus annual comprehensive service keeps systems running reliably. We provide maintenance training for facilities staff or offer service contracts. ",
            },

            {
                question: "Can systems handle both athletic uniforms and hostel bedding?",
                answer: "Absolutely. Our equipment processes diverse loads: heavy athletic gear, delicate uniforms, bulky bedding, towels, and nurse station linens. Different cycle programs accommodate varying fabric types while maintaining hygiene standards and fabric care appropriate for each textile category.",
            },

            {
                question: " How quickly can institutional laundry be operational?",
                answer: "Standard installation takes 5-10 days including equipment setup, utility connections, staff training, and operational testing. We coordinate with academic calendars, working during breaks when possible. Emergency installations for urgent needs can be expedited with advance planning and preparation.",
            },
        ],
    };

    return (
        <>
            <HealthcareBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData} />
            <HealthcareFaq data={faqData} />
        </>
    )
}








